import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormGroupDirective,
  FormArray,
  AbstractControl, ValidationErrors, ValidatorFn
} from "@angular/forms";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import * as _moment from "moment";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject,Renderer2 } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { inject } from 'underscore';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'; // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI

import { ServicioGestionCargueService } from '../../servicios/servicio-gestion-cargue.service';
import { AgenciaService } from '../../servicios/agencia.service';


export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD",
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD",
  },
};


@Component({
  selector: 'app-dialogo-entrega-nueva',
  templateUrl: './dialogo-entrega-nueva.component.html',
  styleUrls: ['./dialogo-entrega-nueva.component.css'],
  providers:[
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
    provide: MAT_DATE_FORMATS, useValue: MY_FORMATS
  }]
})
export class DialogoEntregaNuevaComponent implements OnInit {
  @ViewChild(FormGroupDirective,{static: false})
  formGroupDirective: FormGroupDirective;
  controlesCargue: FormGroup;
  CurrUsuarioConsulta = 0;
  dataSalida: any;
  agencias: any[] = [];
  usuarioConsulta = '';
  infoUsuario: any;

  constructor(
    public dialogRef: MatDialogRef<DialogoEntregaNuevaComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private formBuilder:FormBuilder,
    private servicioGestionCargue: ServicioGestionCargueService,
    private servicioAgencias: AgenciaService,
  ) { 
    this.infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));
    this.usuarioConsulta = this.infoUsuario[0].IdUsuario;

    this.controlesCargue= this.formBuilder.group({
      agencia:        [0 , [Validators.required ,this.customValidatorAgenciaFn()]],
      ordenSap:       ["" , Validators.required ],
      entrega:        ["" , Validators.required ],
      pedido:         ["" , Validators.required ],
      nombre:         ["" , Validators.required ],
      telefono:       ["" , Validators.required ],
      direccion:      ["" , Validators.required ],
      ciudad:         ["" , Validators.required ],
      articulo:       ["" , Validators.required ],
      tienda:         ["" , Validators.required ],
      cantidad:       [1 , Validators.required ],
      fechaEnt:       ["" , Validators.required ],
      ruta:           ["" , Validators.required ],
      cedula:         ["" , Validators.required ],
      placa:          ["" , Validators.required ],
      cdr:            ["" , Validators.required ],
      estado:         ["" , Validators.required ],
      fechaCarga:     [new Date() , Validators.required ],
      fechaVenta:     [new Date() , Validators.required ],
      tipoEntrega:    ["" , Validators.required ]
    });
  }

  ngOnInit() {
    this.cargarAgencias();
  }

  cargarAgencias(){
    this.servicioAgencias.getAgencia(this.infoUsuario[0].IdUsuario, 0)
    .subscribe(result => {
      this.agencias = result;
      this.controlesCargue.controls['agencia'].setValue('0');
      //console.log(this.agencias);
    });
  }

  guardarDocumento(){
    Swal.fire({
      title: 'Guardando datos !',
      html: 'Un momento por favor.',// add html attribute if you want or remove
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      onBeforeOpen () {
        Swal.showLoading ();
      },
      // willOpen: () => {
      //   Swal.showLoading();
      // },
    });

    let FechaCarga = _moment(
      this.controlesCargue.controls["fechaCarga"].value,
      "YYYY-MM-DD"
    ).format("DD/MM/YYYY");

    let FechaVenta = _moment(
      this.controlesCargue.controls["fechaVenta"].value,
      "YYYY-MM-DD"
    ).format("DD/MM/YYYY");

    let FechaEntrega = _moment(
      this.controlesCargue.controls["fechaEnt"].value,
      "YYYY-MM-DD"
    ).format("DD/MM/YYYY");


    
    let entrega : Entrega={
      idUsuarioConsulta:  this.usuarioConsulta,
      idAgencia:          this.controlesCargue.controls["agencia"].value,
      ordenSap:           this.controlesCargue.controls["ordenSap"].value,
      entrega:            this.controlesCargue.controls["entrega"].value,
      pedido:             this.controlesCargue.controls["pedido"].value,
      nombre:             this.controlesCargue.controls["nombre"].value,
      telefono:           this.controlesCargue.controls["telefono"].value,
      direccion:          this.controlesCargue.controls["direccion"].value,
      ciudad:             this.controlesCargue.controls["ciudad"].value,
      articulo:           this.controlesCargue.controls["articulo"].value,
      tienda:             this.controlesCargue.controls["tienda"].value,
      cantidad:           this.controlesCargue.controls["cantidad"].value,
      fechaEnt:           FechaEntrega,
      ruta:               this.controlesCargue.controls["ruta"].value,
      cedula:             this.controlesCargue.controls["cedula"].value,
      placa:              this.controlesCargue.controls["placa"].value,
      cdr:                this.controlesCargue.controls["cdr"].value,
      estado:             this.controlesCargue.controls["estado"].value,
      fechaCarga:         FechaCarga,
      fechaVenta:         FechaVenta,
      tipoEntrega:        this.controlesCargue.controls["tipoEntrega"].value
    };

    console.log(entrega);

    this.servicioGestionCargue
    .EntregaNueva(entrega)
    .subscribe(() => {
      Swal.close();
      Swal.fire({
        title: "Cargue Guardado",
        text: "Se ha guardado el cargue con exito.",
        type: "success",
        confirmButtonColor: '#127570',
        allowOutsideClick: false,
      }).then((result) => {
        this.dataSalida = {
          resultado: 'OK',
        };
        this.dialogRef.close(this.dataSalida);
      }
      );
    });


    // this.servicioGestionCargue
    //   .EntregaVerificar(entrega)
    //   .subscribe((result) => {
    //     if (result.length == 0) {
    //       this.servicioGestionCargue
    //         .EntregaNueva(entrega)
    //         .subscribe(() => {
    //           Swal.close();
    //           Swal.fire({
    //             title: "Cargue Guardado",
    //             text: "Se ha guardado el cargue con exito.",
    //             type: "success",
    //             confirmButtonColor: '#127570',
    //             allowOutsideClick: false,
    //           }).then((result) => {
    //             this.dataSalida = {
    //               resultado: 'OK',
    //             };
    //             this.dialogRef.close(this.dataSalida);
    //           }
    //           );
    //         });
    //     }
    //     else{
    //       console.log(result);
    //       Swal.close();
    //       Swal.fire({
    //         title: "Cargue Atencion",
    //         text: "Este cargue ya se encuentra programado.",
    //         type: "warning",
    //         confirmButtonColor: '#127570',
    //         allowOutsideClick: false,
    //       });
    //     }
    //   });


  }

  private customValidatorAgenciaFn(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valid: boolean = (control.value > 0);
      return valid ? null : { amountMinError: true };
    };
  }

  cancelar(){
    this.dataSalida = {
      resultado: 'KO',
    };
    this.dialogRef.close(this.dataSalida);
  }

}
interface Entrega {
  idUsuarioConsulta:  string;
  idAgencia:          number;
  ordenSap:           string;
  entrega:            string;
  pedido:             string;
  nombre:             string;
  telefono:           string;
  direccion:          string;
  ciudad:             string;
  articulo:           string;
  tienda:             string;
  cantidad:           number;
  fechaEnt:           string;
  ruta:               string;
  cedula:             string;
  placa:              string;
  cdr:                string;
  estado:             string;
  fechaCarga:         string;
  fechaVenta:         string;
  tipoEntrega:        string;
}